document.addEventListener('DOMContentLoaded', () => {
	const blocks = document.querySelectorAll('.rmh-partnership-opportunities');

	blocks.forEach((block) => {
		// Block initialization logic.
	});
});
